<span class="sh-icon-badge">
    <svg sh-icon class="sh-icon" [name]="icon"></svg>
    <span *ngIf="count !== null" class="sh-icon-badge__badge {{size}} {{type}}">{{count}}</span>
</span>
